/**
 * Messages
 */
const messages = require('../../messages');

/**
 * Repositories
 */
const permissionIdentities = require('../../permission-identities');

/**
 * Request schemas
 */
const requestSchemas = require('../../request-schemas');

/**
 * Scopes
 */
const scopes = require('../../scopes');

module.exports = [{
  action: 'getSystemGames',
  message: messages.SUCCESS_GET_SYSTEM_GAMES,
  method: 'GET',
  path: '/system/:systemId/games',
  payloadType: 'collection',
  permissionIdentity: permissionIdentities.GET_SYSTEM_GAME,
  requestSchema: requestSchemas.systemGames.getSystemGames,
  scopes: [scopes.DEFAULT],
}];
